import rootReducer from "../reducers/root-reducer";
import rootSaga from "../sagas/root-sagas";
import { createHashHistory } from "history";
import createSagaMiddleware from "@redux-saga/core";
import { routerMiddleware } from "react-router-redux";
import { applyMiddleware, createStore } from "redux";

const sagaMiddleware = createSagaMiddleware();
const history = createHashHistory();
const routerWare = routerMiddleware(history);
const store = createStore(rootReducer, applyMiddleware(sagaMiddleware, routerWare));
sagaMiddleware.run(rootSaga);

export default store;
